import React, { ChangeEvent, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

interface SearchTextFieldProps {
  width?: string;
  onSearch: (text: string) => void;
}

const SearchTextField = (props: SearchTextFieldProps) => {
  const [value, setValue] = useState('');

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    props.onSearch(e.target.value);
  };

  const onClear = () => {
    setValue('');
    props.onSearch('');
  };

  return (
    <TextField
      id="input-with-icon-textfield"
      sx={{
        minWidth: 120,
        width: props.width || 'auto'
      }}
      size="small"
      variant="outlined"
      margin="dense"
      label="Search"
      value={value}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              sx={value ? { visibility: 'visible' } : { visibility: 'hidden' }}
              onClick={onClear}
            >
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
      onChange={onChange}
    />
  );
};

export default SearchTextField;
